import mirrorCreator from 'mirror-creator';

const actionTypes = mirrorCreator([
  'CREATE_ONLINE_COURSE_ACTIVITY_SHARE',
  'CREATE_ONLINE_COURSE_ACTIVITY_SHARE_SUCCESS',
  'CREATE_ONLINE_COURSE_ACTIVITY_SHARE_FAIL',
]);

export default actionTypes;
